// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import Button from '../../components/Button';
import Column from '../../components/Column';
import Row from '../../components/Row';

const S = {
  Layout: styled(Column)`
    height: 100%;
    width: 100%;
  `,
  LeftWrapper: styled(Column)`
    width: 100%;
    height: 100%;
    justify-content: space-between;
  `,
  FailedWrapper: styled(Column)`
    height: 100%;
    width: 100%;
    padding-top: -9px;
    position: relative;
    justify-content: space-between;
    align-items: center;
  `,
  Container: styled(Row)`
    flex-grow:1;
    max-width: 800px;
    height: 363px;
  `,
  Body: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 51px);
  `,
  Description: styled.div`
    display: flex;
    max-width: 315px;
    font-size: 16px;
    line-height: 23px;
    color: #434343;
    margin-top: 18px;
  `,
  Retry: styled.a`
    color: #EF8200;
    cursor: pointer;
    text-decoration-line: underline;
    text-underline-offset: 2px;
  `,
  Img: styled.img``,
  FailedImg: styled.img`
    width: 220px;
    height: 220px;`,
  Header: styled.img`
    width: 186px;
    height: 26px;
    margin: 25px 0 0 27px;
    `,
  RegisterButton: styled(Button)`
    width: 112px;
    height: 44px;
    font-size: 18px;
    line-height: 26px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    background: #EF8200;
    border-radius: 4px;
    box-shadow: revert;
    margin-top: 40px;
  `,
  Button: styled(Button)`
    width: 112px;
    height: 44px;
    font-size: 18px;
    line-height: 26px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    background: #EF8200;
    border-radius: 4px;
    box-shadow: revert;
  `,
  Title: styled.div`
    font-weight: 500;
    font-size: 24px;
    line-height: 35px;
    color: #434343;
    display: flex;
  `,
  DescriptionWrapper: styled.div`
    font-size: 16px;
    line-height: 23px;
    color: #434343;
    display: flex;
    flex-direction: column;
  `,
  EmailLabel: styled.div``,
  Email: styled.div`
    font-weight: bold;
    font-size: 16px;
    line-height: 23px;
    color: #434343;
    display: flex;
  `,
  LoadingContainer: styled.div`
    display: flex;
    margin: auto;
    place-content: center;
  `,
  FailedTitle: styled.div`
    font-weight: 500;
    font-size: 24px;
    line-height: 35px;
    color: #434343;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  FailedDescription: styled.div`
    font-size: 16px;
    line-height: 23px;
    color: #666666;
    margin-top: 9px;
    align-items: center;
    justify-content: center;
  `,
  FailedDescriptionWrapper: styled.div`
    font-size: 16px;
    line-height: 23px;
    color: #434343;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `,
}
export { S as default }
